export default {
  'get-list': {
    method: 'post',
    url: '/client/commodity/history/list/ID'
  },
  'get-by-id': {
    method: 'get',
    url: '/client/commodity/history/ID'
  }
}
